
























import breakpoints from 'library/assets/vars/breakpoints'
export default

	props:
		# Array of items like [ { id:Number, title:String } ]
		items: Array

		# Index of the currently selected item
		carouselIndex: Number

	methods:
		itemClick: (index) -> @$emit 'click', index

